import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";

const LiveViewRecordingsVideoListNoS3Videos = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        py: 6,
        px: 2,
        height: "220px",
        textAlign: "center",
        color: "text.secondary",
      }}
    >
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.divider}`,
          borderRadius: "8px",
          width: 48,
          height: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 1.5,
        }}
      >
        <FormatListBulletedOutlinedIcon color="action" />
      </Box>
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        No videos yet
      </Typography>
      <Typography variant="body2">
        The videos you retrieve will appear here
      </Typography>
    </Box>
  );
};

export default LiveViewRecordingsVideoListNoS3Videos;
